import React, { useEffect, useState } from "react";
import { useAppLibs } from "../../ContextProvider/AppLib_Provider";
import Utils from "../../utils/utils";
import { useToast } from "../ToastContext";

const CreateTicket = ({ props }) => {
  const { onClose, setTickets } = props;
  const { Tickets } = useAppLibs();
  const showToast = useToast();
  const STATUS = Tickets.STATUS;
  const PRIORITY = Tickets.PRIORITY;
  const [CATEGORY, setCategories] = useState(Tickets.CATEGORY["LMS"]);

  const [isValidUrl, setIsValidUrl] = useState(true);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    category: "",
    product: "LMS",
    attachment: "",
    priority: "1",
  });

  // Handle input changes
  const handleChange = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateURL = function (url) {
    try {
      new URL(url); // If URL is valid, no error will be thrown
      return true;
    } catch {
      return false;
    }
  };

  const handleBlur = () => {
    if (formData.attachment) {
      const ret = validateURL(formData.attachment);
      setIsValidUrl(ret);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    if (formData.attachment) {
      const ret = validateURL(formData.attachment);
      if (!ret) {
        alert("Please enter a valid URL.");
        return;
      }
    }
    formData["attachments"] = [formData.attachment];
    const t = Utils.getCurrentTime();
    formData["createdAt"] = t;
    const result = await Tickets.createTicket(formData);
    setLoading(false);

    if (result.success) {
      const tck = result.data.ticket;
      setTickets((prev) => [tck, ...prev]);
      showToast("Ticket created successfully!", "success", true, 2000);
      setFormData({
        title: "",
        description: "",
        category: "",
        product: "LMS",
        attachment: "",
        priority: "1",
      });
      onClose();
    } else {
      showToast(result.error, "error", true, 2000);
    }
  };

  return (
    <div className="flex justify-center items-center bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded-lg shadow-md "
      >
        <h1 className="text-2xl font-bold text-gray-800 mb-4">Create Ticket</h1>

        <div className="mb-4">
          <label htmlFor="category" className="block font-medium text-gray-700">
            Category
          </label>
          <select
            id="category"
            name="category"
            value={formData.category}
            onChange={handleChange}
            required
            className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select a category</option>
            {Object.entries(CATEGORY).map(([id, name]) => (
              <option key={id} value={id}>
                {name}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-4">
          <label htmlFor="title" className="block font-medium text-gray-700">
            Title <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
            className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="mb-4">
          <label
            htmlFor="description"
            className="block font-medium text-gray-700"
          >
            Description <span className="text-red-500">*</span>
          </label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
            rows="4"
            className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          ></textarea>
        </div>

        <div className="mb-4">
          <label htmlFor="priority" className="block font-medium text-gray-700">
            Priority
          </label>
          <select
            id="priority"
            name="priority"
            value={formData.priority}
            onChange={handleChange}
            className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {Object.entries(PRIORITY).map(([key, value]) => (
              <option key={key} value={key}>
                {value.name}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-4">
          <label
            htmlFor="attachment"
            className="block font-medium text-gray-700"
          >
            Attachment (Optional)
          </label>
          <input
            type="text"
            id="attachment"
            name="attachment"
            value={formData.attachment}
            onChange={handleChange}
            onBlur={handleBlur} // Validate on blur
            className={`mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 ${
              isValidUrl ? "focus:ring-blue-500" : "focus:ring-red-500"
            }`}
            placeholder="Enter the image or drive link"
          />

          <p className="text-xs text-gray-500 mt-2 italic">
            Please save the screenshot in the drive link and then submit here if
            any.
          </p>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className={`px-4 py-2 text-white font-bold rounded ${
              loading ? "bg-gray-500" : "bg-blue-500 hover:bg-blue-700"
            }`}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateTicket;
